/**
 * Created by Andrey Popov on 9/19/25.
 */

const UnitsForFogsPasteHandler = function () {
};

UnitsForFogsPasteHandler.prototype.isApplicable = function (clipboardData) {
    const data = this._extractData(clipboardData);
    return data && data.meta && data.meta.type === "UnitsForFogs";
};

UnitsForFogsPasteHandler.prototype.countItems = function (clipboardData) {
    return this._extractData(clipboardData).data.length;
};

UnitsForFogsPasteHandler.prototype.paste = function (clipboardData) {
    const units = this._extractData(clipboardData).data;
    const groupedUnits = this._groupUnitsByFogs(units);
    this._fitUnitsToFogs(groupedUnits);

    Map2d.updateMap();
    Map2d.currentMap.saveLevel();
};

UnitsForFogsPasteHandler.prototype._extractData = function (clipboardData) {
    let data = undefined;
    try {
        data = JSON.parse(clipboardData);
    } catch (e) {
        console.log(e);
        return false;
    }
    return data;
};

UnitsForFogsPasteHandler.prototype._groupUnitsByFogs = function (unitsData) {
    const groups = {};
    const heads = {};
    const multicells = {};

    for (const u of unitsData) {
        const fogId = u.fog;
        if (!fogId) {
            continue;
        }

        const id = this._getKey(u);
        if (!groups[fogId]) {
            groups[fogId] = {};
        }

        groups[fogId][id] = (groups[fogId][id] || 0) + 1;

        if (u.isHead) {
            heads[fogId] = id;
        }

        if (Unit.GetShape(u).length > 1) {
            if (!multicells[fogId]) {
                multicells[fogId] = [];
            }
            multicells[fogId].push(id);
        }
    }

    const sortedGroups = {};
    Object.keys(groups).forEach((fogId) => {
        const fogGroup = groups[fogId];
        const headId = heads[fogId];
        const multicellIds = multicells[fogId];
        const ordered = {};

        if (headId) {
            ordered[headId] = fogGroup[headId];
            delete fogGroup[headId];
        }

        for (const id of Object.keys(fogGroup)) {
            if (multicellIds && multicellIds.includes(id)) {
                ordered[id] = fogGroup[id];
                delete fogGroup[id];
            }
        }

        for (const [unitKey, count] of Object.entries(fogGroup)) {
            ordered[unitKey] = count;
        }

        sortedGroups[fogId] = ordered;
    });

    return sortedGroups;
};

UnitsForFogsPasteHandler.prototype._fitUnitsToFogs = function (groupedUnits) {
    let summary = "";
    const map = Map2d.currentMap;
    const location = cleverapps.meta.getSelectedLocation().locationId;
    const editor = Editor && Editor.currentEditor;

    const skipped = {};
    const unknown = {};
    const fullFogs = [];

    if (editor) {
        editor.beginBatch();
    }

    Object.keys(groupedUnits).forEach((fogName) => {
        console.log(`Paste in fog ${fogName}`);
        fogName = fogName.replace("{location}", location);
        if (!map.regions[fogName]) {
            summary += `\nMissing region ${fogName}. Region's units skipped`;
            return;
        }

        const existingFogUnits = {};
        map.regions[fogName].positions.forEach((p) => {
            const unit = map.getUnit(p.x, p.y);
            if (unit) {
                const id = this._getKey(unit);
                existingFogUnits[id] = (existingFogUnits[id] || 0) + 1;
            }
        });

        const fogUnits = {};
        for (const key in groupedUnits[fogName]) {
            if (groupedUnits[fogName][key]) {
                const countNew = groupedUnits[fogName][key];
                const countOld = existingFogUnits[key] || 0;
                const diff = countNew - countOld;
                if (diff > 0) {
                    fogUnits[key] = diff;
                }
            }
        }

        const emptyCellsInFog = map.regions[fogName].positions.filter((p) => !map.getUnit(p.x, p.y)).map((p) => Unit.GetPositionKey(p));
        const headPos = map.regions[fogName].head ? Unit.GetPositionKey(map.regions[fogName].head) : undefined;
        let placedToHead = false;

        while (Object.keys(fogUnits).length > 0) {
            let placedAny = false;

            for (const unitKey in fogUnits) {
                console.log(`     ${unitKey}`);

                const locked = unitKey.endsWith("_lock");
                const unitData = Unit.ParseKey(unitKey.replace("_lock", ""));

                if (emptyCellsInFog.length === 0) {
                    if (!fullFogs.includes(fogName)) {
                        fullFogs.push(fogName);
                    }
                    skipped[unitKey] = (skipped[unitKey] || 0) + fogUnits[unitKey];
                    delete fogUnits[unitKey];
                    continue;
                }

                let posKey = !placedToHead && headPos ? headPos : emptyCellsInFog[0];
                if (Families[unitData.code].units[unitData.stage].source && posKey === headPos && emptyCellsInFog[1]) {
                    posKey = emptyCellsInFog[1];
                }

                if (!this._hasPlace(posKey, unitData, emptyCellsInFog) && emptyCellsInFog.indexOf(posKey) !== -1) {
                    for (let i = emptyCellsInFog.indexOf(posKey); i < emptyCellsInFog.length; i++) {
                        if (this._hasPlace(emptyCellsInFog[i], unitData, emptyCellsInFog)) {
                            posKey = emptyCellsInFog[i];
                            break;
                        }
                    }
                }
                if (headPos === posKey) {
                    placedToHead = true;
                }

                const pos = Unit.ParsePositionKey(posKey);
                unitData.x = pos.x;
                unitData.y = pos.y;

                fogUnits[unitKey]--;
                if (fogUnits[unitKey] === 0) {
                    delete fogUnits[unitKey];
                }

                if (!Families[unitData.code] || !Families[unitData.code].expeditions.includes(location)) {
                    unknown[unitKey] = (unknown[unitKey] || 0) + 1;
                } else {
                    if (Families[unitData.code].units[unitData.stage].source) {
                        unitData.grounded = true;
                    }
                    if (locked) {
                        unitData.lock = 1;
                    }
                    if (editor) {
                        editor.doCommand("produceUnit", { unit: unitData, x: pos.x, y: pos.y });
                    } else {
                        map.createUnit(pos.x, pos.y, unitData);
                    }
                    this._occupyCells(unitData, emptyCellsInFog);
                }

                placedAny = true;
            }

            if (!placedAny) {
                break;
            }
        }
    });

    if (editor) {
        editor.endBatch();
    }

    if (summary.length > 0 || Object.keys(skipped).length > 0) {
        if (Object.keys(skipped).length > 0) {
            summary += `Skipped units (not enough cells in fogs ${fullFogs.join(", ")}):\n`;
            for (const [unitKey, count] of Object.entries(skipped)) {
                summary += `- ${unitKey}: ${count}\n`;
            }
        }
        if (Object.keys(unknown).length > 0) {
            summary += "\n\nUnknown units (unknown family):\n";
            for (const [unitKey, count] of Object.entries(unknown)) {
                summary += `- ${unitKey}: ${count}\n`;
            }
        }

        setTimeout(() => {
            alert(summary);
        }, 0);
    }
};

UnitsForFogsPasteHandler.prototype._hasPlace = function (posKey, unitData, emptyCellsInFog) {
    let result = true;
    const pos = Unit.ParsePositionKey(posKey);
    Unit.GetShape(unitData).forEach((cellToDelete) => {
        const keyToUnit = Unit.GetPositionKey({
            x: pos.x + cellToDelete.x,
            y: pos.y + cellToDelete.y
        });
        if (emptyCellsInFog.indexOf(keyToUnit) === -1) {
            result = false;
        }
    });
    return result;
};

UnitsForFogsPasteHandler.prototype._occupyCells = function (unitData, emptyCellsInFog) {
    Unit.GetShape(unitData).forEach((cellToDelete) => {
        const keyToDelete = Unit.GetPositionKey({
            x: unitData.x + cellToDelete.x,
            y: unitData.y + cellToDelete.y
        });
        const index = emptyCellsInFog.indexOf(keyToDelete);
        if (index !== -1) {
            emptyCellsInFog.splice(index, 1);
        }
    });
};

UnitsForFogsPasteHandler.prototype._getKey = function (unit) {
    let key = Unit.GetKey(unit);
    if (unit.lock) {
        key += "_lock";
    }
    return key;
};

ClipboardService.REGISTERED_PASTE_HANDLERS.push(UnitsForFogsPasteHandler);